// @docs https://[domain]/api/v1/docs
export default {
  Create: "/pyr/run",
  CheckRule: "/pyr/payrolls/check-rule",
  LockData: "/pyr/locks",
};
